import { Select, SelectProps } from "antd";
import { EditableColumnProps, EditableTable } from "Components/General/EditableTable";
import { I18N_NS } from "Config/i18n";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

interface OxModulesOptionsProps {
  value?: API_OxModule[];
  onChange?: (v: API_OxModule[]) => API_OxModule[];
}

export const OxModulesOptions: React.FC<OxModulesOptionsProps> = ({ value, onChange }) => {
  const { t } = useTranslation(I18N_NS.ADMIN);
  const TYPE_NAMES: { key: API_PROJECT_STARTWITH; label: string }[] = [
    { key: "ONLINEBAUABNAHME", label: "Defects" },
    { key: "CONSTRUCTIONLOG", label: "Journal" },
    { key: "OX_FOTOS", label: "Fotos" },
    { key: "OX_CHECKLISTS", label: "Checklists" },
  ];

  const handleDeleteRow = (id: number) => {
    const newValue = value.filter((item) => item.id !== id);
    onChange(newValue);
  };

  const handleAddRow = (record: API_OxModule) => {
    if (typeof onChange !== "function") {
      console.warn("onChange handler is not set up!");
    } else {
      const newValue = [...value, record];
      onChange(newValue);
    }
    return Promise.resolve();
  };

  const handleEditRow = (record: API_OxModule) => {
    const idx = value.findIndex((item) => record.id === item.id);
    const newValue = value;
    if (idx !== -1) {
      newValue[idx] = record;
    }
    onChange(newValue);
  };

  const columns: EditableColumnProps<API_OxModule>[] = [
    {
      title: t("Type"),
      dataIndex: "module",
      editable: true,
      width: 250,
      defaultSortOrder: "ascend",
      inputType: "select",
      inputProps: {
        children: TYPE_NAMES.map((name) => (
          <Select.Option key={name.key} title={name.label} value={name.key}>
            {t(name.label)}
          </Select.Option>
        )),
        filterOption: (inputValue = "", option) =>
          option.title && option.title.toString().toLowerCase().indexOf(inputValue.toLowerCase()) !== -1,
      } as SelectProps<number>,
      formItemProps: {
        rules: [{ required: true, message: t("Please provide a name") }],
      },
      render: (value) => t(TYPE_NAMES.find((v) => v.key === value)?.label),
    },
    {
      title: t("Display name"),
      dataIndex: "displayname",
      editable: true,
      inputType: "text",
      inputProps: {
        style: { width: "100%" },
      },
      formItemProps: {
        rules: [{ required: true, message: t("Please provide a display name") }],
      },
    },
    {
      title: t("OX project"),
      dataIndex: "oxid",
      editable: true,
      inputType: "text",
      inputProps: {
        style: { width: "100%" },
      },
      formItemProps: {
        rules: [{ required: true, message: t("Please provide a short name") }],
      },
    },
  ];

  useEffect(() => {
    console.log(value.slice());
  }, [value]);

  return (
    <EditableTable<API_OxModule>
      name="oxModuleOptions"
      rowIdKey="id"
      columns={columns}
      dataSource={[...value]}
      onDelete={handleDeleteRow}
      onAddRow={handleAddRow}
      rowDeletable
      rowEditable
      onEdit={handleEditRow}
      showAddRow={true}
      style={{ width: "100%" }}
      scroll={{ x: 1000 }}
    />
  );
};
